import { Config } from '@customTypes/config'
import { getRegion } from './region'

export const fallbackLanguage = (config: Config) => {
  const currentRegion = getRegion(config)

  if (currentRegion === 'EU') return 'en-EU'
  else if (currentRegion === 'AU') return 'en-AU'

  return 'en-US'
}

export const isArabic = (locale: string) => {
  const arabicLocale = ['ar-sa', 'ar-sa-sa']

  return arabicLocale.includes(locale.toLowerCase())
  // return arabicLocale.some(x => locale.toLowerCase().startsWith(x))
}
